import { createAction } from 'redux-actions';

import types from './types';

const setResultCategories = createAction(types.SET_CATEGORIES);
const setResultSuggestions = createAction(types.SET_CONTENT_SUGGESTIONS);
const setResultProducts = createAction(types.SET_PRODUCTS);
const setResultStores = createAction(types.SET_STORES);
const setResultAutoSuggestions = createAction(types.SET_AUTO_SUGGESTIONS);
const setResultBaseUrlSuffix = createAction(types.SET_BASE_URL_SUFFIX);
const clearRecentSearches = createAction(types.CLEAR_RECENT_SEARCHES);
const addRecentSearch = createAction(types.ADD_RECENT_SEARCH);
const setRecentSearch = createAction(types.SET_RECENT_SEARCH);
const getRecentSearch = createAction(types.GET_RECENT_SEARCH);
const setValue = createAction(types.SET_VALUE);
const setInputValue = createAction(types.SET_INPUT_VALUE);
const setStaticSuggestion = createAction(types.SET_STATIC_SUGGESTION);
const setAPIResponseSucceded = createAction(types.SET_API_RESPONSE_SUCCEDED);
const doSearch = createAction(types.DO_SEARCH);
const changeFilter = createAction(types.CHANGE_FILTER);
const changeSorting = createAction(types.CHANGE_SORTING);
const clearFilters = createAction(types.CLEAR_FILTERS);
const clearFiltersGroup = createAction(types.CLEAR_GROUP_OF_FILTERS);
const applyFilters = createAction(types.APPLY_FILTERS);
const setNewDoc = createAction(types.SET_NEW_DOC);
const setFiltersAreApplied = createAction(types.SET_FILTERS_ARE_APPLIED);
const setFiltersValidated = createAction(types.SET_FILTERS_VALIDATED);
const setFilterLoading = createAction(types.FILTER_LOADING);
const doFilterByValue = createAction(types.DO_FILTER_BY_VALUE);
const getSecondaryResultsTotal = createAction(types.GET_SECONDARY_RESULTS_TOTAL);
const setSecondaryResultsTotal = createAction(types.SET_SECONDARY_RESULTS_TOTAL);
const setBrandSuggestions = createAction(types.SET_BRAND_SUGGESTIONS);
const setHasExternalCatalogsMapping = createAction(types.SET_HAS_EXTERNAL_CATALOGS_MAPPING);
const getPopularSuggestions = createAction(types.GET_POPULAR_SUGGESTIONS);
const setPopularSuggestions = createAction(types.SET_POPULAR_SUGGESTIONS);
const setSuggestionsReceived = createAction(types.SET_SUGGESTIONS_RECEIVED);
const setFilterGroupExpanded = createAction(types.SET_FILTER_GROUP_EXPANDED);
const setSuggestionsOpened = createAction(types.SET_SUGGESTIONS_OPENED);
const setLastSearch = createAction(types.SET_LAST_SEARCH);
const setSearchFromCategories = createAction(types.SET_SEARCH_FROM_CATEGORIES);
const clearLastChangedFiltersGroup = createAction(types.CLEAR_LAST_CHANGED_FILTERS_GROUP);
const clearFiltersBeforeRender = createAction(types.CLEAR_FILTERS_BEFORE_RENDER);
const setFilterAccordionOpened = createAction(types.SET_FILTER_ACCORDION_OPENED);
const removeSelectedFacetGroups = createAction(types.REMOVE_SELECTED_FACET_GROUPS);
const updatePageByUrl = createAction(types.UPDATE_PAGE_BY_URL);
const setFilterPriceRange = createAction(types.SET_FILTER_PRICE_RANGE);
const setNoResultsMessage = createAction(types.SET_NO_RESULTS_MESSAGE);
const setHasResults = createAction(types.SET_HAS_RESULTS);
export const searchProduct = createAction(types.SEARCH_PRODUCT);
const setSearchForExtService = createAction(types.SET_SEARCH_FOR_EXT_SERVICE);
const addSelectedFacetGroup = createAction(types.ADD_SELECTED_FACET_GROUP);
const setExternalCatalogsMapping = createAction(types.SET_EXTERNAL_CATALOGS_MAPPING);
const setRemoveSeoText = createAction(types.SET_REMOVE_SEO_TEXT);

export default {
    setResultCategories,
    setResultProducts,
    setResultSuggestions,
    setResultStores,
    setResultAutoSuggestions,
    setResultBaseUrlSuffix,
    clearRecentSearches,
    addRecentSearch,
    setRecentSearch,
    getRecentSearch,
    setValue,
    setInputValue,
    setStaticSuggestion,
    setAPIResponseSucceded,
    doSearch,
    changeFilter,
    changeSorting,
    clearFilters,
    applyFilters,
    setNewDoc,
    setFiltersAreApplied,
    setFiltersValidated,
    setFilterLoading,
    doFilterByValue,
    getSecondaryResultsTotal,
    setSecondaryResultsTotal,
    setBrandSuggestions,
    getPopularSuggestions,
    setPopularSuggestions,
    setSuggestionsReceived,
    setFilterGroupExpanded,
    setSuggestionsOpened,
    setLastSearch,
    clearFiltersGroup,
    setSearchFromCategories,
    clearLastChangedFiltersGroup,
    clearFiltersBeforeRender,
    setFilterAccordionOpened,
    removeSelectedFacetGroups,
    updatePageByUrl,
    setFilterPriceRange,
    setNoResultsMessage,
    setHasResults,
    searchProduct,
    setSearchForExtService,
    addSelectedFacetGroup,
    setExternalCatalogsMapping,
    setRemoveSeoText,
    setHasExternalCatalogsMapping,
};
